import React from "react";
import { Toaster } from "sonner";

const AppToaster = () => {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      duration={5000}
      expand={false}
      toastOptions={{
        className: "blufield-toast",
      }}
    />
  );
};

export default AppToaster;
